// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasStatus_UpdateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/despesas_status/update
 *
 * Updates an existing expense status.
 */
import { registerContract } from './validate'

export interface DespesasStatus_UpdateInput {
despesa_status_id: number
despesa_status_titulo?: string
}

registerContract('DespesasStatus_UpdateInput', {
  despesa_status_id:     { type: 'number',  required: true },
  despesa_status_titulo: { type: 'string',  required: false },
})
